const middleware = ({ store }) => {
    if (store.state.damagesValuation.departments !== null) {
        return;
    }
    return store.dispatch('damagesValuation/fetchDepartments');
};
export default middleware;
